import toast from "react-hot-toast";
import { api } from "../../api/api";
import {
  DELETE_SCREEN,
  SCREEN_STATUS_DEACTIVE,
  SCREEN_STATUS_ACTIVE,
  SCREEN_SOCKET_ONLINE,
  SCREEN_SOCKET_OFFLINE,
  ADD_SCREEN_REQUEST,
  ADD_SCREEN_SUCCESS,
  SCREEN_REQUEST,
  SCREEN_REQUEST_SUCCESS,
  SCREEN_REQUEST_FAILED,
  ADD_SCREEN_TO_PLAYLIST,
  ADD_PLAYLIST_TO_SCREEN,
  UNCHECK_ASSIGNED_SCREEN,
  SCREEN_FLAG_OFF,
  FIND_ONE_SCREEN,
  CLIENT_SCREENS_REQUEST,
  CLIENT_SCREENS_SUCCESS,
  UPDATE_SCREEN,
  UPDATE_SCREEN_SUCCESS,
  COUNT_STATS_OF_SCREEN_REQ,
  COUNT_STATS_OF_SCREEN
} from "../constant";

export const addScreen = (data, code) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_SCREEN_REQUEST,
      payload: "",
    });
    const codeNorm = String(code ?? "")
      .replace(/\s/g, "")
      .trim();
    if (!codeNorm) {
      toast.error("Pair code is required.");
      dispatch(screenFlagOff());
      return;
    }
    try {
      const updated = await api.patch(`/screen/update/${codeNorm}`, data);
      if (!updated.data?.screen) {
        toast.error(
          "No screen found for this code. Open Web player first (pairing), then enter the code as digits only — e.g. 6610 not 6 6 1 0."
        );
        dispatch(screenFlagOff());
        return;
      }
      dispatch({ type: ADD_SCREEN_SUCCESS, payload: updated.data.screen });
      toast.success("Screen added");
    } catch (e) {
      toast.error(
        e.response?.data?.error || e.message || "Could not add screen."
      );
      dispatch(screenFlagOff());
    }
  };
};

export const updateScreen = (_data, id) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_SCREEN_REQUEST,
      payload: "",
    });
    const {status,data} = await api.patch(`/screen/editscreen/${id}`, _data);
   if(status==200)
    dispatch({ type: UPDATE_SCREEN_SUCCESS, payload: data.updatedScreen });
  };
};

export const countOfStatsScreen=(id)=>{
  return async (dispatch)=>{
    dispatch({
      type: COUNT_STATS_OF_SCREEN_REQ,
      payload: "",
    });
    const {status,data}=await api.get(`/screen/countstatsofscreen/${id}`);
    if(status==200){
          dispatch({
            type:COUNT_STATS_OF_SCREEN,
            payload:data.screen_stats
          })
    }
  }
}

export const getScreens = (id, options = {}) => {
  return async (dispatch) => {
    
    dispatch({ type: SCREEN_REQUEST, payload: "" });
    
    const { page = 1, limit = 10, search } = options;
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search })
    });
    
    try {
      const screens = await api.get(`/screen/getscreens/${id}?${params}`);
      
      if (screens.status === 200) {
        if (screens.data.screens.length > -1) {
          dispatch({ 
            type: SCREEN_REQUEST_SUCCESS, 
            payload: {
              screens: screens.data.screens,
              pagination: screens.data.pagination
            }
          });
        }
        else {
          dispatch({
            type: SCREEN_REQUEST_FAILED,
            payload: ''
          })
        }
      }
    } catch (error) {
      console.error('Error in getScreens:', error);
      console.error('Error response:', error.response);
      console.error('Error status:', error.response?.status);
      console.error('Error data:', error.response?.data);
      
      dispatch({
        type: SCREEN_REQUEST_FAILED,
        payload: error.response?.data || error.message,
      });
    }
  };
};
export const screenStatusActive = (mac, status) => {
  return async (dispatch) => {
    const updated = await api.patch(
      `/screen/screenstatusupdate/${encodeURIComponent(mac)}`,
      { status }
    );
    if (updated.status === 201) {
      dispatch({
        type: SCREEN_STATUS_ACTIVE,
        payload: updated.data.updated,
      });
    }
  };
};
export const screenStatusDeActive = (mac, status) => {
  return async (dispatch) => {
    const updated = await api.patch(
      `/screen/screenstatusupdate/${encodeURIComponent(mac)}`,
      { status }
    );
    if (updated.status === 201) {
      dispatch({
        type: SCREEN_STATUS_DEACTIVE,
        payload: updated.data.updated,
      });
    }
  };
};
export const deleteScreen = (id) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_SCREEN,
      payload: id,
    });
    await api.get(`/screen/deletescreen/${id}`);
  };
};
export const addPlaylistToScreen = (obj) => {
  return async (dispatch) => {
    const screen = await api.patch(
      `/screen/addplaylisttoscreen/${obj.id}`,
      {
        playlistId: obj.value,
        mac:obj.mac
      }
    );
    // console.log('updated playlist assigning=',screen);
    if (screen.status === 201) {
      dispatch({
        type: ADD_PLAYLIST_TO_SCREEN,
        payload: screen.data.screen,
      });
    }
  };
}
export const uncheckAssignedScreen = (id) => {
  return async (dispatch) => {
    dispatch({
      type: UNCHECK_ASSIGNED_SCREEN,
      payload: id
    })
  }
}
export const screenFlagOff = () => {
  return async (dispatch) => {
    dispatch({
      type: SCREEN_FLAG_OFF,
      payload: ''
    })
  }
}

export const screenSocketOnline = (mac) => ({
  type: SCREEN_SOCKET_ONLINE,
  payload: typeof mac === 'string' ? mac.trim() : mac,
});

export const screenSocketOffline = (mac) => ({
  type: SCREEN_SOCKET_OFFLINE,
  payload: typeof mac === 'string' ? mac.trim() : mac,
});
export const findOneScreen = (id) => {
  return async (dispatch) => {
    dispatch({
      type: FIND_ONE_SCREEN,
      payload: id
    })
  }
}
export const getClientScreens = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CLIENT_SCREENS_REQUEST,
      payload: ''
    });

    const { status, data } = await api.get(`/screen/getclientscreens/${id}`);
    if (status === 200) {
      dispatch({
        type: CLIENT_SCREENS_SUCCESS,
        payload: data.screens
      })
    }
  }
}